export default "__VITE_ASSET__k2G1QXJB__"